import { FC } from 'react';
import ImageComponentRender from './ImageComponentRender';

export interface IImageStaticDisplay {
  node: {
    attrs: {
      src?: string;
      alt?: string;
    };
  };
}

const ImageStaticDisplay: FC<IImageStaticDisplay> = ({ node }) => {
  const attrs = node.attrs;
  // console.log('ImageDisplay attrs:', attrs);

  return (
    <ImageComponentRender />
  );
};

export default ImageStaticDisplay;
